import React, { useContext } from 'react';

import { AnimateSharedLayout } from 'framer-motion';
import { Route, Switch } from 'react-router-dom';

import { AuthContext } from '@/core/auth/AuthContext';
import { UserInvite } from '@/core/users/UserInvite/UserInvite';
import { UserInviteContextProvider } from '@/core/users/UserInvite/UserInviteContext';
import { UserManagement } from '@/core/users/UserManagement/UserManagement';
import { UserSearchContextProvider } from '@/core/users/UserManagement/UserSearchContext';
import { UserEditContextProvider } from '@/core/users/UserPermissions/UserEditContext';
import { UserPermissions } from '@/core/users/UserPermissions/UserPermissions';
import routes from '@/routes';

export default function UsersRoutes () {
  const { currentUser, hasCoreAccess, hasUvkAccess } = useContext(AuthContext);
  let canInvite = (hasCoreAccess && currentUser?.coreOwner) || (hasUvkAccess && currentUser?.uvkAdmin);
  if (!currentUser) {
    return null;
  }

  return (
    <AnimateSharedLayout>
      <Switch>
        {canInvite && (
          <Route path={routes.users.invite}>
            <UserInviteContextProvider>
              <UserInvite />
            </UserInviteContextProvider>
          </Route>
        )}
        <Route path={routes.users.permissions}>
          <UserEditContextProvider>
            <UserPermissions />
          </UserEditContextProvider>
        </Route>
        <Route path={routes.users.self}>
          <UserSearchContextProvider>
            <UserManagement />
          </UserSearchContextProvider>
        </Route>
      </Switch>
    </AnimateSharedLayout>
  );
}
